import type { CaseStudySection } from './amexCaseStudy';
export const rsiIntro = {
  client: 'RSI',
  title: 'Modernizing platform architecture to improve profitability by 46%',
  summary: 'Redesigned the core architecture of a patient communications SaaS product supporting 2,000+ providers, cutting support volume and shortening time-to-value.',
  background: 'linear-gradient(180deg, #F4E6E4 0%, #D7C5C1 100%)'
};
export const rsiMetrics = [{
  value: '54→79%',
  label: 'gross profit margin'
}, {
  value: '22→28%',
  label: 'conversion'
}, {
  value: '$1.5M',
  label: 'contract value'
}];
export const rsiSections: CaseStudySection[] = [{
  label: 'Problem',
  heading: 'A product that was expensive to sell and support',
  paragraphs: ['Onboarding could take 12 weeks, and admins had to call support for simple tasks. The dated UI also made the product look more complicated than it was, which hurt sales.']
}, {
  label: 'Challenge',
  heading: 'What I was working with',
  paragraphs: ['The platform was so complex that self-service was nearly impossible. Support picked up the slack, spending a lot of time with clients to set up and configure the system. There were over 150 screens of UI, some of which were obsolete.']
}, {
  label: 'Approach',
  heading: 'Rolling it out in phases',
  paragraphs: ['I introduced a rail navigation to separate the major sections of the product, then redesigned one section at a time so the work could ship sooner. I started from Material Design because it works well with Angular, which kept engineering costs down.']
}, {
  label: 'Results',
  heading: 'Prototype and results',
  paragraphs: ["I built a full prototype of the product in Figma and tested it with users before launch. Later I rebuilt it in Magic Patterns. Profit margin rose from 54% to 79%, driven by lower support and onboarding costs. One major client's lead-to-scheduled conversion went from 22% to 28%. The product also became credible for larger accounts, up to $1.5M per year per contract."]
}, {
  figures: [{
    src: 'https://cdn.magicpatterns.com/uploads/i153t7huV5A4wxqJTJxwUg/inbox.jpg',
    alt: 'RSI unified inbox with filters by message type, assignee, location, and tag, a conversation list, and an open patient thread with attached consent forms',
    caption: 'Universal inbox for phone, SMS, email, fax, and more.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/iHjDcWcLoBVtoZCTjsVMgS/kanban.jpg',
    alt: 'CRM board view of leads organized into columns from Lead Created through Closed',
    caption: 'Kanban view of leads moving from first contact to close.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/pBQZ6t5TCku63QLKEMCyB7/audiences.jpg',
    alt: 'Create Audience screen with a filter list, configured birthday and appointment filters, and a live preview list of matching contacts',
    caption: 'Audience builder with live preview of matching contacts.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jTcEhe5F3RjL1VjsHLr86N/reports.jpg',
    alt: 'Patient Acquisition report with headline KPIs, a monthly leads trend chart, leads by campaign, and leads by source',
    caption: 'Patient acquisition reporting at a glance.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/4tQ8eBvSpdrx2cjxAjxFwA/provider.jpg',
    alt: 'Edit Provider panel separating synced EHR fields from editable platform settings and provider details',
    caption: 'Provider settings, with EHR-synced fields clearly separated.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/4SxerV9Y31TnMcZUMo3LFC/widget.jpg',
    alt: 'Embed Scheduling Widget settings with configuration options and a live phone-sized preview of the booking flow',
    caption: 'Scheduling widget setup with a live preview.'
  }]
}];